import $store from 'good-storage'

export const userStatus = (state, user) => {
  if (user) {
    state.currentUser = user
    state.isLogin = true
    $store.set('user', user)
    $store.session.set('user', user)
  } else if (user === null) {
    $store.clear()
    state.currentUser = null
    state.isLogin = false
    state.Authorization = ''
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js